import { memo } from 'react';
import useChartUpdate from '../UseChartUpdate';
var Title = /*#__PURE__*/memo(function (props) {
  useChartUpdate(props, updateTitle, function (chart) {
    return updateTitle(chart, {
      text: null
    });
  });
  return null;
});

var updateTitle = function updateTitle(chart, config) {
  chart.setTitle(config, null, false);
};

Title.displayName = 'Title';
export default Title;